export default class Image {
  constructor(
    id,
    src,
    name,
    alt
  ) {
    this.id = id
    this.src = src
    this.name = name
    this.alt = alt
  }
}
